module.exports = __webpack_public_path__ + "img/docsIcon.2965e724.svg";